// src/terms/Disclaimer.jsx
import React from "react";
import { ReactComponent as Disclaimer_icon } from "../icons/Disclaimer_icon.svg";


export function Disclaimer() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <Disclaimer_icon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>LegendsTools Disclaimer | Terms & Conditions | Governing Law</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>1. Allgemeiner Hinweis</h2>
      <p style={p}>Die auf dieser Website bereitgestellten Inhalte und Tools (nachfolgend „Dienst“) dienen 
      ausschließlich der informationellen Nutzung. Es handelt sich nicht um amtliche Auskünfte, rechtsverbindliche Informationen,
       Zusicherungen oder verbindliche Bewertungen.</p>
      <br />
      
      
      {/* Vertretungsberechtigter */}
      <h2 style={h2}>2. Funktionsumfang & Datenquellen</h2>
      <p style={p}>Die angebotenen Funktionen basieren auf öffentlich zugänglichen oder nutzereingebundenen Daten,
       die automatisiert verarbeitet und dargestellt werden. Trotz sorgfältiger Entwicklung kann nicht ausgeschlossen werden, dass:</p>
      <br />
    
      • einzelne Daten unvollständig, veraltet oder fehlerhaft sind,
      <br />
      • Berechnungen oder Visualisierungen Abweichungen enthalten,
      <br />
      • externe Datenquellen temporär nicht verfügbar sind oder sich ändern.
      <br /> <br />
      <p style={p}>Nutzer erkennen an, dass technische und inhaltliche Abweichungen grundsätzlich möglich sind.</p>


      {/* 3. COOKIES */}
      <h2 style={h2}>3. Keine Haftung für Nutzungsergebnisse</h2>
      <p style={p}>Die Nutzung der bereitgestellten Informationen, Karten, Statistiken oder Auswertungen erfolgt auf eigenes Risiko.
      Legendstools haftet insbesondere nicht für:</p>
      <br />
      <p style={p}>• Entscheidungen, die auf Grundlage der bereitgestellten Daten getroffen werden,</p>
      <p style={p}>• Schäden, Verluste oder Nachteile infolge von Nutzung oder Nichtnutzung,</p>
      <p style={p}>• mittelbare oder indirekte Schäden (z. B. entgangener Gewinn, Projektverzug, Spielfortschritt, Datenverluste).</p>
      
      

      {/* 4. KONTAKT */}
      <h2 style={h2}>4. Technische Verfügbarkeit</h2>
      <p style={p}>
      Es besteht kein Anspruch auf jederzeitige Verfügbarkeit, Fehlerfreiheit oder bestimmte Performance.
      Legendstools kann den Dienst jederzeit ändern, einschränken oder einstellen.
      </p>
    
      {/* 5. EXTERNE INHALTE */}
      <h2 style={h2}>5. Externe Inhalte & Links</h2>
      <p style={p}>
      Soweit externe Inhalte, Karten oder Websites eingebunden oder verlinkt sind, liegt deren Verantwortung ausschließlich beim jeweiligen Anbieter.
      Legendstools macht sich diese Inhalte ausdrücklich nicht zu eigen.
      </p>

       {/* 6. Internationale Nutzung & Rechtsrahmen */}
       <h2 style={h2}>6. Internationale Nutzung & Rechtsrahmen</h2>
      <p style={p}>
      Legendstools kann weltweit genutzt werden:
      </p>
      <br />
      <p style={p}>• Für sämtliche Zugriffe auf die Website sowie für deren Nutzung gilt ausschließlich das Recht der Bundesrepublik Deutschland, unabhängig davon,
      aus welchem Land auf den Dienst zugegriffen wird.</p>
      <br />
      <p style={p}>• Ausschließlicher Gerichtsstand für alle Streitigkeiten im Zusammenhang mit der Nutzung dieser Website ist Göttingen, Bundesrepublik Deutschland, 
       sofern der Nutzer Kaufmann, eine juristische Person des öffentlichen Rechts oder ein öffentlich-rechtliches Sondervermögen ist oder
      keinen allgemeinen Gerichtsstand in Deutschland hat.</p>

      {/* 7. Internationale Nutzung & Rechtsrahmen */}
      <h2 style={h2}>7. Technische Hinweise & Haftungsbeschränkung</h2>
      <p style={p}>
      Die Verfügbarkeit und Funktionsfähigkeit der Website hängt von verschiedenen technischen Faktoren ab (z. B. Server, Netzwerke, Browser, Endgeräte, Drittanbieter-Infrastruktur). 
      Trotz sorgfältiger Wartung kann eine jederzeitige, unterbrechungsfreie oder fehlerfreie Nutzung nicht zugesichert werden.

      Wir haften nicht für Schäden, die aus Störungen, Verzögerungen, Ausfällen, Datenverlust, Übertragungsfehlern oder technischen Problemen entstehen,
      die außerhalb unseres Einflussbereichs liegen. Dies gilt insbesondere für:
      </p>
      <br />
      <p style={p}>• Netzwerk- oder Serverausfälle,</p>
      <p style={p}>• Provider- oder Hosting-Störungen,</p>
      <p style={p}>• Hard- oder Softwarefehler auf Seiten des Nutzers,</p>
      <p style={p}>• Eingriffe oder Blockaden durch Browser- oder Sicherheitseinstellungen,</p>
      <p style={p}>• Kompatibilität mit allen Browsern oder Endgeräten.</p>
      <p style={p}>• höhere Gewalt im Sinne von § 275 Abs. 1 BGB.</p>
      <br />
      <p style={p}>Ansprüche wegen Vorsatz oder grober Fahrlässigkeit bleiben hiervon unberührt.</p>
      

      <div style={small}>
      Copyright © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH.
      </div>
    </div>
  );
}


